module.exports = __webpack_public_path__ + "img/auto_market_pop.5f4c5a28.jpg";